import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import ListGroupArticles from "@/components/organisms/groups/ListGroupArticles";
import { getMonthString } from "@/utils/dateParser";
import { fetchArticlesData } from "@/services/contentEvents/actions";
import * as DateParser from "@/utils/dateParser";
import ArticleCard from '@/components/molecules/ArticleCard'

import "./lists.scss";
import Axios from "axios";

class ArticlesList extends React.Component {
	state = {
		articles: [],
		activeCategory: ''
	}
	articlesOrderedByMonth = null
	articlesFilteredByAuthor = null
	categories

	constructor(props) {
		super(props)
		props.fetchArticlesData(this.props.data.sourcedata)
			.then(() => this.fetchArticlesContent()
				.then(response => { response === 'noResult' ? this.renderNoResult(response) : this.sortArticles(response) }));
		this.setState({ activeCategory: 'all' })
		this.author = props.author
	}

	getGroupColor(index) {
		if (index % 3 === 0) {
			return "green";
		}
		if ((index + 1) % 3 === 0) {
			return "red";
		}
		return "blue";
	}

	getMonths() {
		if (!this.articlesOrderedByMonth) {
			return null;
		}
		return Object.keys(this.articlesOrderedByMonth).map((key, index) => {
			return key;
		});
	}

	orderArticlesByDate(articleCollection) {
		return articleCollection.sort((a, b) => {
			let dateA, dateB
			for (let i = 0; i < a.data.contents[0].fields.length; i++) {
				if (a.data.contents[0].fields[i].id === 'datepublished') {
					dateA = moment(DateParser.formatDateWithSlashes(a.data.contents[0].fields[i].value))
					break
				}
			}
			for (let j = 0; j < b.data.contents[0].fields.length; j++) {
				if (b.data.contents[0].fields[j].id === 'datepublished') {
					dateB = moment(DateParser.formatDateWithSlashes(b.data.contents[0].fields[j].value))
					break
				}
			}
			return dateA.isBefore(dateB) ? -1 : 1;
		});
	}

	filterArticlesByAuthor(articlesSortedByDate) {
		this.articlesFilteredByAuthor = articlesSortedByDate.filter(item => {
			let author = this.author
			for (let j = 0; j < item.data.contents[0].fields.length; j++) {
				if (item.data.contents[0].fields[j].id === 'authorinfo') {
					for (let k = 0; k < item.data.contents[0].fields[j].fields.length; k++) {
						if (item.data.contents[0].fields[j].fields[k].id === 'slug' && item.data.contents[0].fields[j].fields[k].value === author) {
							return true
						}
					}
				}
			}
		})
	}

	groupArticlesDataByMonth(articlesSortedByDate) {
		this.articlesOrderedByMonth = {};
		const today = moment().add(1, "days");

		articlesSortedByDate.forEach(item => {
			let date
			for (let j = 0; j < item.data.contents[0].fields.length; j++) {
				if (item.data.contents[0].fields[j].id === 'datepublished') {
					date = item.data.contents[0].fields[j].value
					break
				}
			}

			const month = getMonthString(date);
			if (moment(DateParser.formatDateWithSlashes(date)).isBefore(today)) {
				if (!this.articlesOrderedByMonth[month]) {
					this.articlesOrderedByMonth[month] = [];
				}
				this.articlesOrderedByMonth[month].push(item);
			}
		});
	}

	renderNoResult(response) {
		this.setState({ articles: response })
	}

	renderArticlesList() {
		if (!this.articlesOrderedByMonth) return

		const commonProps = {
			cta: this.props.data.readmoretext,
			nocontent: this.props.data.noresultmessage
		};
		const currMonth = DateParser.nextNMonths()[0];

		if (this.articlesOrderedByMonth) {
			return Object.keys(this.articlesOrderedByMonth).map((key, index) => {
				const optionalTitle =
					key === currMonth ? this.props.data.optional_heading : null;
				return (
					<ListGroupArticles
						key={`eventsgroup_${index}`}
						routeProps={this.props.routeProps}
						articles={this.articlesOrderedByMonth[key]}
						title={key}
						color={this.getGroupColor(index)}
						optionalTitle={optionalTitle}
						activeCategory={this.state.activeCategory}
						{...commonProps}
					/>
				);
			});
		}
	}

	renderArticles() {
		if (!this.articlesFilteredByAuthor) return

		let ind = 0

		return (
			<div className='List'>
				<div className='list-group'>
					<div className='list-group__container'>
						{this.articlesFilteredByAuthor.map(article => {
							if (article) {
								ind++
								return (
									<ArticleCard
										key={`home-events_${ind}`}
										article={article}
										isActive={true}
										cta={'Read More'}
										{...this.props}
									/>
								)
							}
						})}
					</div>
				</div>
			</div>
		)

		return
	}

	getCategories(articleCollection) {
		let categoryList = []
		for (let article of articleCollection) {
			for (let i = 0; i < article.data.contents[0].fields.length; i++) {
				if (article.data.contents[0].fields[i].id === 'categoryfilters') {
					let category = article.data.contents[0].fields[i].fields[0].value
					if (category && !categoryList.includes(category)) {
						categoryList.push(category)
					}
				}
			}
		}

		this.categories = categoryList
	}

	async getArticleContent(url) {
		return Axios.get(url)
	}

	async fetchArticlesContent() {
		let that = this
		let articlesContent = ''

		console.log('artdata: ', that.props.articlesData)
		if (that.props.articlesData.length === 1 && that.props.articlesData[0].urlslug === 'empty-journal') {
			return 'noResult'
		} else {

			let articleUrls = that.props.articlesData.map((article) => {
				return article.journalentry
			})

			articlesContent = articleUrls.map(async (url) => {
				let contents = await this.getArticleContent(url)
				return contents
			})
		}

		return articlesContent
	}

	sortArticles(stuff) {
		return Promise.all(stuff)
			.then(function (vals) { return vals })
			.then((lot) => {
				let returnval = this.orderArticlesByDate(lot)
				this.setState({ articles: returnval })
			})
	}

	handleCategoryClick(selectedCat) {
		this.setState({ activeCategory: selectedCat })
	}

	render() {
		if (!this.props.articlesData.length) {
			return null;
		}

		let allArticlesSortedByDate = this.state.articles

		if (allArticlesSortedByDate === 'noResult') {
			return (<div className='articlelistwrap'>
				<div className='empty-msg'>
					<div className='empty-msg__heading'>
						<h2>There are no recent articles.<br />To keep up with the latest from Guinness Open Gate Brewery, visit our <a href="/events">Events page</a>.</h2>
					</div>
				</div>
			</div>)
		} else {

			let authorListing = this.author

			if (!this.author) {
				if (!this.articlesOrderedByMonth && this.state.articles.length) {
					this.groupArticlesDataByMonth(this.state.articles);
				}

				if (!this.categories && this.state.articles.length) {
					this.getCategories(this.state.articles)
				}
			} else {
				console.log('renderauth: ', this.author)
				this.filterArticlesByAuthor(this.state.articles)
			}

			return (authorListing ?
				<div className='articlelistwrap author'>
					{this.articlesFilteredByAuthor && <div className="List">{this.renderArticles()}</div>}
				</div>
				:
				<div className='articlelistwrap'>
					{this.categories &&
						<div className='articlelistwrap__cats'>
							<span className={this.state.activeCategory === 'all' ? 'articlelistwrap__cat-title--active' : 'articlelistwrap__cat-title'} onClick={() => { this.handleCategoryClick('all') }}>All</span>
							{this.categories.map((cat) => {
								return <span className={this.state.activeCategory === cat ? 'articlelistwrap__cat-title--active' : 'articlelistwrap__cat-title'} onClick={() => { this.handleCategoryClick(cat) }}>{cat}</span>
							})}
						</div>
					}
					{this.articlesOrderedByMonth && <div className="List">{this.renderArticlesList()}</div>}
				</div>
			)
		}
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		articlesData: state.pageContent.articlesData
	};
};

export default connect(
	mapStateToProps,
	{ fetchArticlesData }
)(ArticlesList);



// WEBPACK FOOTER //
// ./src/components/organisms/lists/ArticlesList.js